// Mirrors dotnet/Data/Trillion.Data/Enums/UserStatus.cs 1:1 (the ids are the `user_status`
// lookup-table ids in every product database). Change one side, change both.
export enum UserStatus {
  Active = 1,
  Suspended = 2,
  Deleted = 3,
  Invited = 4,
}
